<template>
  <div>
    footer
  </div>
</template>
<script>
export default {
  data () {
    return {
    
    }
  }
}
</script>


// WEBPACK FOOTER //
// Footer.vue?73654e3e